// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./variables.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Tussilago/Tussilago.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Tussilago/Tussilago.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Tussilago/Tussilago.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Riforma/Riforma Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/Riforma/Riforma Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/Riforma/Riforma Bold Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/Riforma/Riforma Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/Riforma/Riforma Heavy.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/Riforma/Riforma Heavy Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/Riforma/Riforma Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/Riforma/Riforma Light Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/Riforma/Riforma Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fonts/Riforma/Riforma Medium Italic.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("fonts/Eastlane/Eastlane Black Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("fonts/Eastlane/Eastlane Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("fonts/Eastlane/Eastlane Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("fonts/Eastlane/Eastlane Light Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("fonts/Eastlane/Eastlane Bold Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("fonts/Eastlane/Eastlane Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("fonts/Eastlane/Eastlane Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("fonts/Eastlane/Eastlane Medium Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("fonts/Eastlane/Eastlane Book Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("fonts/Eastlane/Eastlane Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("fonts/Eastlane/Eastlane Book.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("fonts/Eastlane/Eastlane Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("fonts/Eastlane/Eastlane Extra Light Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("fonts/Eastlane/Eastlane Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("fonts/Eastlane/Eastlane Extra Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("fonts/Eastlane/Eastlane Thin Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("fonts/Eastlane/Eastlane Heavy Slant.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("fonts/Eastlane/Eastlane Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\"><polygon fill=\"%23c1c3d1\" points=\"0,0 10,0 5,6\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Tussilago';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
       url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Bold Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'Riforma Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Riforma Heavy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype');
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Heavy Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('opentype');
  font-weight: 900;
  font-style: italic;
}

@font-face {
  font-family: 'Riforma Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('opentype');
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Light Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('opentype');
  font-weight: 300;
  font-style: italic;
}

@font-face {
  font-family: 'Riforma Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('opentype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Riforma Medium Italic';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('opentype');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'Eastlane Black Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Heavy';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Black';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Light Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Bold Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Bold';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Medium Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Book Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Medium';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Book';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Extra Light Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Extra Light';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Thin Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Heavy Slant';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format('truetype');
}

@font-face {
  font-family: 'Eastlane Thin';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format('truetype');
}


html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  font-family: "Eastlane Medium", "Montserrat", sans-serif; 
}

.dashboardRoot {
  background-color: var(--background-color); 
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 64px;
  font-family: "Eastlane Medium", "Montserrat", sans-serif; 
  overflow-y: auto;
}

.logo {
  width: 140px;
}

.logo:visited, .logo:hover, .logo:active {
  text-decoration: none;
}

.cardHeader {
  text-align: center;
  font-size: 30px;
  margin-bottom: 20px;
  font-family: "Riforma Medium", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cardHeader .card-header-secondary-text {
  color: var(--secondary-text-color);
}

.cardHeader .card-header-highlight-text {
  color: var(--highlight-color);
}

.card-header-sub-text {
  font-family: "Riforma Regular", sans-serif;
  color: var(--disabled-color);
  text-align: center;
  font-size: 1rem;
  margin-top: 15px;
  width: 45%;
}

.containerWrapper {
  display: flex;
  justify-content: space-between; /* Adjusts space between items */
  align-items: center; /* Aligns items vertically in the center */
  padding: 0 20px; /* Adds padding for spacing */
  justify-content: center;
  align-items: center;
}

.container {
  padding-top: 60px;
  width: 80vw;
  height: 430px;
  border-radius: 10px;
}

h1, h2 {
  color: var(--text-color); 
}

label {
  display: block;
  color: var(--secondary-text-color); 
  font-family: "Riforma Bold", sans-serif;
}

select, input {
  font-family: "Riforma Regular", sans-serif;
  appearance: none; /* Remove default browser styling on select */
  box-sizing: border-box; /* Include padding and borders in width calculation */
  margin-top: 10px;
  margin-bottom: 20px;
  border: 1px solid var(--secondary-color); /* Dark border for inputs */
  border-radius: 5px; /* Ensure consistent border-radius */
  background-color: var(--background-color); /* Dark background for inputs */
  padding: 15px;
  width: 100%; /* Ensure both elements take the full width of their container */
  color: var(--text-color);
  font-size: 15px;
  font-weight: 500;
}

select { 
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___}); /* SVG down arrow */
  background-position: right 10px center;
  background-size: 8px 10px;
  background-repeat: no-repeat;
}

select:hover, input:hover {
  border-color: var(--secondary-highlight-color);
}

.custom-select {
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  width: 100%;
  height: auto;
  min-height: auto;
  color: var(--text-color);
  font-family: "Riforma Regular", sans-serif;
}

/* Define the glow animation */
@keyframes glow {
  0% {
    box-shadow: 0 0 10px rgba(55, 83, 108, 0.4); /* Start with a soft glow */
  }
  50% {
    box-shadow: 0 0 15px rgba(55, 83, 108, 0.6); /* Slightly increase the glow */
  }
  100% {
    box-shadow: 0 0 10px rgba(55, 83, 108, 0.4); /* Dim back to original */
  }
}

.unselected {
  animation: glow 2s infinite; /* Apply glow animation */
}

.custom-select {
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  font-family: 'Riforma Bold', sans-serif;
}

.custom-select .react-select__control, .year-select .react-select__control {
  cursor: text;
  border: 1px solid var(--secondary-color);
  background: var(--tertiary-background-color);
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
  color: var(--secondary-text-color);
  padding: 5px;
  border-radius: 5px;
  font-weight: 600;
}

.custom-select .react-select__control--is-focused,
.custom-select .react-select__control:hover {
  border-color: var(--secondary-highlight-color); /* Blue border on hover and focus */
}

.custom-select .react-select__control--menu-is-open .react-select__single-value {
  color: var(--secondary-background-color);
}

.custom-select .react-select__menu {
  z-index: 9999;
  background: var(--background-color);
  border-radius: 5px;
}

.custom-select .react-select__option {
  color: var(--secondary-text-color);
  border-radius: 5px;
  padding: 10px;
}

.custom-select .react-select__option--is-selected {
  background-color: var(--background-color);
  color: var(--text-color);
}

.custom-select .react-select__option--is-focused {
  background-color: var(--secondary-highlight-color);
  color: var(--text-color);
}

.custom-select .react-select__single-value {
  color: var(--text-color);
}

.custom-select .react-select__placeholder {
  opacity: 1;
  transition: opacity 0.2s ease;
  color: var(--secondary-text-color);
}

.custom-select .react-select__control--is-focused .react-select__placeholder {
  opacity: 0; /* Hide placeholder when focused */
}

.custom-select .react-select__indicator-separator {
  display: none;
}

.custom-select .react-select__dropdown-indicator,
.custom-select .react-select__clear-indicator {
  color: var(--secondary-text-color);
}

.custom-select .react-select__input {
  color: var(--text-color)!important; /* Ensure the text color is white */
}

.react-select__multi-value {
  color: var(--background-color)!important;
  border-radius: 36px!important; 
  padding: 5px 10px; /* Add some padding */
  margin: 5px; /* Space between pills */
}

/* .react-select__multi-value__remove:hover {
  background-color: var(--secondary-text-color)!important;
  color: var(--secondary-text-color)!important;
} */

.custom-option {
  display: flex;
  align-items: center;
  background-color: var(--background-color); /* Background for the entire row */
  cursor: pointer;
  border-radius: 5px;
  font-weight: 500;
}

.custom-option:hover {
  background-color: var(--secondary-highlight-color); /* Highlight background on hover */
}

/* Symbol section on the left */
.custom-option .symbol {
  background-color: var(--hover-color); /* Different background color for symbol */
  padding: 9px 15px 5px 15px;
  border-radius: 36px; /* Make corners more rounded */
  color: var(--background-color); /* Symbol text color */
  margin-right: 10px; /* Space between symbol and company name */
  margin-left: 5px;
  font-weight: 700;
  /* margin-top: 5px; */
  margin-bottom: 5px;
  text-align: center; /* Center text horizontally */
  /* border: 1px solid var(--text-color); */
}

/* Company name on the right */
.custom-option .company {
  color: var(--secondary-text-color); /* Different color for the company name */
}

.clearAllIndicator {
  background: var(--secondary-color);
  border-radius: 46px;
  padding: 4px 7px;
  color: var(--secondary-text-color);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.clearAllIndicator:hover {
  background: var(--secondary-highlight-color);
}

input[type="number"] {
  -moz-appearance: textfield; /* Hide the default arrows in Firefox */
}

/* Hide default spinners in Chrome/Safari */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none; /* Remove the default styling */
  margin: 0; /* Remove default margin */
}


select { /* Remove default dropdown arrow on WebKit browsers */ /* Remove default dropdown arrow on Mozilla browsers */
  appearance: none; /* Remove default dropdown arrow on all browsers */
}

button {
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: none;
  border-radius: 36px;
  background: var(--highlight-color);
  padding: 12px;
  width: 100%;
  color: var(--background-color); 
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  margin-top: 15px;
}

button:disabled {
  background: var(--disabled-color);
  cursor: not-allowed;
}

button:disabled:hover {
  border: none;
  background: var(--disabled-color);
}

button:hover {
  background-color: var(--hover-color); /* Slightly darker blue on hover */
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  90% {
    opacity: 1; /* Keep it fully visible for most of the time */
  }
  100% {
    opacity: 0; /* Fade out at the end */
  }
}

.success, .error {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: var(--secondary-background-color);
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  opacity: 1;
  transition: opacity 1s ease-out;
  font-family: 'Montserrat', sans-serif;
  animation: fadeOut 5s forwards; /* 10 second fade-out */
}

.success-message {
  font-family: 'Montserrat', sans-serif;
  animation: fadeOut 5s forwards; /* 10 second fade-out */
  color: black;
  background-color: var(--bg-positive);
  border: 1px solid var(--success-color);
  padding: 10px;
  transition: opacity 1s ease-out;
  margin-top: 15px;
  border-radius: 36px;
  font-weight: 500;
}

.error-message {
  font-family: 'Montserrat', sans-serif;
  animation: fadeOut 5s forwards; /* 10 second fade-out */
  color: var(--error-color);
  border: 1px solid var(--error-color);
  background-color: var(--secondary-background-color);
  padding: 10px;
  transition: opacity 1s ease-out;
  margin-top: 15px;
  border-radius: 5px;
}


.success {
  color: var(--success-color);
  border: 1px solid var(--success-color);
}

.error {
  color: var(--error-color);
  border: 1px solid var(--error-color);
}

.success svg, .error svg {
  width: 24px;
  height: 24px;
}

.dismiss-button {
  background: none;
  cursor: pointer;
  font-size: 15px;
  margin-left: auto;
  width: 20%;
  color: var(--highlight-color);
  font-family: 'Montserrat', sans-serif;
}

.dismiss-button:hover {
  color: var(--text-color);
  background: none;
}

/* Mobile adjustments */
@media only screen and (max-width: 600px) {
  .dashboardRoot {
    padding-top: 95px;
  }


  .logo {
    font-size: 20px;
    top: 30px;
    left: 25px;
  }

  .navbar {
    top: 15px;
    z-index: 999;
  }

  .navbar ul {
    gap: 10px;
  }

  .container {
    width: 100%;
    padding: 10px;
    box-shadow: none;
  }

  .containerWrapper {
    flex-direction: column;
  }

  button {
    font-size: 14px;
    padding: 10px;
  }
}

@media only screen and (max-width: 400px) {
  .success, .error {
    right: 10px;
    bottom: 10px;
    padding: 5px;
    font-size: 12px;
  }

  .dismiss-button {
    font-size: 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;EACE,wBAAwB;EACxB;;iEAE4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,+DAAgE;EAChE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,+DAA6D;EAC7D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,+DAAoE;EACpE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+DAA8D;EAC9D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gEAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gEAA+D;EAC/D,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gEAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gEAAsE;AACxE;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,gEAAsE;AACxE;;AAEA;EACE,kCAAkC;EAClC,gEAAqE;AACvE;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;EACE,4BAA4B;EAC5B,gEAA+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,gEAAuE;AACzE;;AAEA;EACE,kCAAkC;EAClC,gEAAqE;AACvE;;AAEA;EACE,8BAA8B;EAC9B,gEAAiE;AACnE;;AAEA;EACE,4BAA4B;EAC5B,gEAA+D;AACjE;;AAEA;EACE,+BAA+B;EAC/B,gEAAkE;AACpE;;AAEA;EACE,yCAAyC;EACzC,gEAA4E;AAC9E;;AAEA;EACE,6BAA6B;EAC7B,gEAAgE;AAClE;;AAEA;EACE,mCAAmC;EACnC,gEAAsE;AACxE;;AAEA;EACE,kCAAkC;EAClC,gEAAqE;AACvE;;AAEA;EACE,mCAAmC;EACnC,gEAAsE;AACxE;;AAEA;EACE,4BAA4B;EAC5B,gEAA+D;AACjE;;;AAGA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,gCAAgC;EAChE,mBAAmB,EAAE,0CAA0C;EAC/D,eAAe,EAAE,6BAA6B;EAC9C,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB,EAAE,6CAA6C;EAC/D,sBAAsB,EAAE,qDAAqD;EAC7E,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC,EAAE,2BAA2B;EACrE,kBAAkB,EAAE,oCAAoC;EACxD,yCAAyC,EAAE,+BAA+B;EAC1E,aAAa;EACb,WAAW,EAAE,gEAAgE;EAC7E,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0DAA+K,EAAE,mBAAmB;EACpM,sCAAsC;EACtC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,8BAA8B;AAC9B;EACE;IACE,2CAA2C,EAAE,2BAA2B;EAC1E;EACA;IACE,2CAA2C,EAAE,+BAA+B;EAC9E;EACA;IACE,2CAA2C,EAAE,yBAAyB;EACxE;AACF;;AAEA;EACE,2BAA2B,EAAE,yBAAyB;AACxD;;AAEA;EACE,wDAAwD;EACxD,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,4CAA4C;EAC5C,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,8CAA8C,EAAE,mCAAmC;AACrF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,kDAAkD;EAClD,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,UAAU,EAAE,kCAAkC;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC,EAAE,mCAAmC;AACzE;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;EAC7B,iBAAiB,EAAE,qBAAqB;EACxC,WAAW,EAAE,wBAAwB;AACvC;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC,EAAE,kCAAkC;EAC7E,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD,EAAE,kCAAkC;AACxF;;AAEA,+BAA+B;AAC/B;EACE,oCAAoC,EAAE,0CAA0C;EAChF,0BAA0B;EAC1B,mBAAmB,EAAE,8BAA8B;EACnD,8BAA8B,EAAE,sBAAsB;EACtD,kBAAkB,EAAE,0CAA0C;EAC9D,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;EACjD,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,kCAAkC,EAAE,yCAAyC;AAC/E;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B,EAAE,uCAAuC;AACrE;;AAEA,2CAA2C;AAC3C;;EAEE,wBAAwB,EAAE,+BAA+B;EACzD,SAAS,EAAE,0BAA0B;AACvC;;;AAGA,SAC4B,qDAAqD,EACxD,sDAAsD;EAC7E,gBAAgB,EAAE,kDAAkD;AACtE;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,oCAAoC,EAAE,kCAAkC;AAC1E;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU,EAAE,+CAA+C;EAC7D;EACA;IACE,UAAU,EAAE,wBAAwB;EACtC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mDAAmD;EACnD,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,qCAAqC;EACrC,8BAA8B,EAAE,uBAAuB;AACzD;;AAEA;EACE,qCAAqC;EACrC,8BAA8B,EAAE,uBAAuB;EACvD,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B,EAAE,uBAAuB;EACvD,yBAAyB;EACzB,oCAAoC;EACpC,mDAAmD;EACnD,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;;EAGA;IACE,eAAe;IACf,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import './variables.css';\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n\n@font-face {\n  font-family: 'Tussilago';\n  src: url('fonts/Tussilago/Tussilago.woff2') format('woff2'),\n       url('fonts/Tussilago/Tussilago.woff') format('woff'),\n       url('fonts/Tussilago/Tussilago.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Regular';\n  src: url('fonts/Riforma/Riforma Regular.otf') format('opentype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Bold';\n  src: url('fonts/Riforma/Riforma Bold.otf') format('opentype');\n  font-weight: bold;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Bold Italic';\n  src: url('fonts/Riforma/Riforma Bold Italic.otf') format('opentype');\n  font-weight: bold;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Riforma Italic';\n  src: url('fonts/Riforma/Riforma Italic.otf') format('opentype');\n  font-weight: normal;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Riforma Heavy';\n  src: url('fonts/Riforma/Riforma Heavy.otf') format('opentype');\n  font-weight: 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Heavy Italic';\n  src: url('fonts/Riforma/Riforma Heavy Italic.otf') format('opentype');\n  font-weight: 900;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Riforma Light';\n  src: url('fonts/Riforma/Riforma Light.otf') format('opentype');\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Light Italic';\n  src: url('fonts/Riforma/Riforma Light Italic.otf') format('opentype');\n  font-weight: 300;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Riforma Medium';\n  src: url('fonts/Riforma/Riforma Medium.otf') format('opentype');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Riforma Medium Italic';\n  src: url('fonts/Riforma/Riforma Medium Italic.otf') format('opentype');\n  font-weight: 500;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: 'Eastlane Black Slant';\n  src: url('fonts/Eastlane/Eastlane Black Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Heavy';\n  src: url('fonts/Eastlane/Eastlane Heavy.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Black';\n  src: url('fonts/Eastlane/Eastlane Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Light Slant';\n  src: url('fonts/Eastlane/Eastlane Light Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Bold Slant';\n  src: url('fonts/Eastlane/Eastlane Bold Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Light';\n  src: url('fonts/Eastlane/Eastlane Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Bold';\n  src: url('fonts/Eastlane/Eastlane Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Medium Slant';\n  src: url('fonts/Eastlane/Eastlane Medium Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Book Slant';\n  src: url('fonts/Eastlane/Eastlane Book Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Medium';\n  src: url('fonts/Eastlane/Eastlane Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Book';\n  src: url('fonts/Eastlane/Eastlane Book.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Regular';\n  src: url('fonts/Eastlane/Eastlane Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Extra Light Slant';\n  src: url('fonts/Eastlane/Eastlane Extra Light Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Slant';\n  src: url('fonts/Eastlane/Eastlane Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Extra Light';\n  src: url('fonts/Eastlane/Eastlane Extra Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Thin Slant';\n  src: url('fonts/Eastlane/Eastlane Thin Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Heavy Slant';\n  src: url('fonts/Eastlane/Eastlane Heavy Slant.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Eastlane Thin';\n  src: url('fonts/Eastlane/Eastlane Thin.ttf') format('truetype');\n}\n\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n  font-family: \"Eastlane Medium\", \"Montserrat\", sans-serif; \n}\n\n.dashboardRoot {\n  background-color: var(--background-color); \n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding-top: 64px;\n  font-family: \"Eastlane Medium\", \"Montserrat\", sans-serif; \n  overflow-y: auto;\n}\n\n.logo {\n  width: 140px;\n}\n\n.logo:visited, .logo:hover, .logo:active {\n  text-decoration: none;\n}\n\n.cardHeader {\n  text-align: center;\n  font-size: 30px;\n  margin-bottom: 20px;\n  font-family: \"Riforma Medium\", sans-serif;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.cardHeader .card-header-secondary-text {\n  color: var(--secondary-text-color);\n}\n\n.cardHeader .card-header-highlight-text {\n  color: var(--highlight-color);\n}\n\n.card-header-sub-text {\n  font-family: \"Riforma Regular\", sans-serif;\n  color: var(--disabled-color);\n  text-align: center;\n  font-size: 1rem;\n  margin-top: 15px;\n  width: 45%;\n}\n\n.containerWrapper {\n  display: flex;\n  justify-content: space-between; /* Adjusts space between items */\n  align-items: center; /* Aligns items vertically in the center */\n  padding: 0 20px; /* Adds padding for spacing */\n  justify-content: center;\n  align-items: center;\n}\n\n.container {\n  padding-top: 60px;\n  width: 80vw;\n  height: 430px;\n  border-radius: 10px;\n}\n\nh1, h2 {\n  color: var(--text-color); \n}\n\nlabel {\n  display: block;\n  color: var(--secondary-text-color); \n  font-family: \"Riforma Bold\", sans-serif;\n}\n\nselect, input {\n  font-family: \"Riforma Regular\", sans-serif;\n  appearance: none; /* Remove default browser styling on select */\n  box-sizing: border-box; /* Include padding and borders in width calculation */\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border: 1px solid var(--secondary-color); /* Dark border for inputs */\n  border-radius: 5px; /* Ensure consistent border-radius */\n  background-color: var(--background-color); /* Dark background for inputs */\n  padding: 15px;\n  width: 100%; /* Ensure both elements take the full width of their container */\n  color: var(--text-color);\n  font-size: 15px;\n  font-weight: 500;\n}\n\nselect { \n  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\"><polygon fill=\"%23c1c3d1\" points=\"0,0 10,0 5,6\"/></svg>'); /* SVG down arrow */\n  background-position: right 10px center;\n  background-size: 8px 10px;\n  background-repeat: no-repeat;\n}\n\nselect:hover, input:hover {\n  border-color: var(--secondary-highlight-color);\n}\n\n.custom-select {\n  box-sizing: border-box;\n  margin-top: 10px;\n  margin-bottom: 20px;\n  border-radius: 5px;\n  width: 100%;\n  height: auto;\n  min-height: auto;\n  color: var(--text-color);\n  font-family: \"Riforma Regular\", sans-serif;\n}\n\n/* Define the glow animation */\n@keyframes glow {\n  0% {\n    box-shadow: 0 0 10px rgba(55, 83, 108, 0.4); /* Start with a soft glow */\n  }\n  50% {\n    box-shadow: 0 0 15px rgba(55, 83, 108, 0.6); /* Slightly increase the glow */\n  }\n  100% {\n    box-shadow: 0 0 10px rgba(55, 83, 108, 0.4); /* Dim back to original */\n  }\n}\n\n.unselected {\n  animation: glow 2s infinite; /* Apply glow animation */\n}\n\n.custom-select {\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n  font-family: 'Riforma Bold', sans-serif;\n}\n\n.custom-select .react-select__control, .year-select .react-select__control {\n  cursor: text;\n  border: 1px solid var(--secondary-color);\n  background: var(--tertiary-background-color);\n  font-size: 15px;\n  font-family: 'Montserrat', sans-serif;\n  color: var(--secondary-text-color);\n  padding: 5px;\n  border-radius: 5px;\n  font-weight: 600;\n}\n\n.custom-select .react-select__control--is-focused,\n.custom-select .react-select__control:hover {\n  border-color: var(--secondary-highlight-color); /* Blue border on hover and focus */\n}\n\n.custom-select .react-select__control--menu-is-open .react-select__single-value {\n  color: var(--secondary-background-color);\n}\n\n.custom-select .react-select__menu {\n  z-index: 9999;\n  background: var(--background-color);\n  border-radius: 5px;\n}\n\n.custom-select .react-select__option {\n  color: var(--secondary-text-color);\n  border-radius: 5px;\n  padding: 10px;\n}\n\n.custom-select .react-select__option--is-selected {\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n.custom-select .react-select__option--is-focused {\n  background-color: var(--secondary-highlight-color);\n  color: var(--text-color);\n}\n\n.custom-select .react-select__single-value {\n  color: var(--text-color);\n}\n\n.custom-select .react-select__placeholder {\n  opacity: 1;\n  transition: opacity 0.2s ease;\n  color: var(--secondary-text-color);\n}\n\n.custom-select .react-select__control--is-focused .react-select__placeholder {\n  opacity: 0; /* Hide placeholder when focused */\n}\n\n.custom-select .react-select__indicator-separator {\n  display: none;\n}\n\n.custom-select .react-select__dropdown-indicator,\n.custom-select .react-select__clear-indicator {\n  color: var(--secondary-text-color);\n}\n\n.custom-select .react-select__input {\n  color: var(--text-color)!important; /* Ensure the text color is white */\n}\n\n.react-select__multi-value {\n  color: var(--background-color)!important;\n  border-radius: 36px!important; \n  padding: 5px 10px; /* Add some padding */\n  margin: 5px; /* Space between pills */\n}\n\n/* .react-select__multi-value__remove:hover {\n  background-color: var(--secondary-text-color)!important;\n  color: var(--secondary-text-color)!important;\n} */\n\n.custom-option {\n  display: flex;\n  align-items: center;\n  background-color: var(--background-color); /* Background for the entire row */\n  cursor: pointer;\n  border-radius: 5px;\n  font-weight: 500;\n}\n\n.custom-option:hover {\n  background-color: var(--secondary-highlight-color); /* Highlight background on hover */\n}\n\n/* Symbol section on the left */\n.custom-option .symbol {\n  background-color: var(--hover-color); /* Different background color for symbol */\n  padding: 9px 15px 5px 15px;\n  border-radius: 36px; /* Make corners more rounded */\n  color: var(--background-color); /* Symbol text color */\n  margin-right: 10px; /* Space between symbol and company name */\n  margin-left: 5px;\n  font-weight: 700;\n  /* margin-top: 5px; */\n  margin-bottom: 5px;\n  text-align: center; /* Center text horizontally */\n  /* border: 1px solid var(--text-color); */\n}\n\n/* Company name on the right */\n.custom-option .company {\n  color: var(--secondary-text-color); /* Different color for the company name */\n}\n\n.clearAllIndicator {\n  background: var(--secondary-color);\n  border-radius: 46px;\n  padding: 4px 7px;\n  color: var(--secondary-text-color);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.clearAllIndicator:hover {\n  background: var(--secondary-highlight-color);\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* Hide the default arrows in Firefox */\n}\n\n/* Hide default spinners in Chrome/Safari */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none; /* Remove the default styling */\n  margin: 0; /* Remove default margin */\n}\n\n\nselect {\n  -webkit-appearance: none; /* Remove default dropdown arrow on WebKit browsers */\n  -moz-appearance: none; /* Remove default dropdown arrow on Mozilla browsers */\n  appearance: none; /* Remove default dropdown arrow on all browsers */\n}\n\nbutton {\n  transition: background-color 0.3s ease;\n  cursor: pointer;\n  border: none;\n  border-radius: 36px;\n  background: var(--highlight-color);\n  padding: 12px;\n  width: 100%;\n  color: var(--background-color); \n  font-size: 16px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  margin-top: 15px;\n}\n\nbutton:disabled {\n  background: var(--disabled-color);\n  cursor: not-allowed;\n}\n\nbutton:disabled:hover {\n  border: none;\n  background: var(--disabled-color);\n}\n\nbutton:hover {\n  background-color: var(--hover-color); /* Slightly darker blue on hover */\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1; /* Keep it fully visible for most of the time */\n  }\n  100% {\n    opacity: 0; /* Fade out at the end */\n  }\n}\n\n.success, .error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: var(--secondary-background-color);\n  padding: 10px;\n  border-radius: 5px;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n  opacity: 1;\n  transition: opacity 1s ease-out;\n  font-family: 'Montserrat', sans-serif;\n  animation: fadeOut 5s forwards; /* 10 second fade-out */\n}\n\n.success-message {\n  font-family: 'Montserrat', sans-serif;\n  animation: fadeOut 5s forwards; /* 10 second fade-out */\n  color: black;\n  background-color: var(--bg-positive);\n  border: 1px solid var(--success-color);\n  padding: 10px;\n  transition: opacity 1s ease-out;\n  margin-top: 15px;\n  border-radius: 36px;\n  font-weight: 500;\n}\n\n.error-message {\n  font-family: 'Montserrat', sans-serif;\n  animation: fadeOut 5s forwards; /* 10 second fade-out */\n  color: var(--error-color);\n  border: 1px solid var(--error-color);\n  background-color: var(--secondary-background-color);\n  padding: 10px;\n  transition: opacity 1s ease-out;\n  margin-top: 15px;\n  border-radius: 5px;\n}\n\n\n.success {\n  color: var(--success-color);\n  border: 1px solid var(--success-color);\n}\n\n.error {\n  color: var(--error-color);\n  border: 1px solid var(--error-color);\n}\n\n.success svg, .error svg {\n  width: 24px;\n  height: 24px;\n}\n\n.dismiss-button {\n  background: none;\n  cursor: pointer;\n  font-size: 15px;\n  margin-left: auto;\n  width: 20%;\n  color: var(--highlight-color);\n  font-family: 'Montserrat', sans-serif;\n}\n\n.dismiss-button:hover {\n  color: var(--text-color);\n  background: none;\n}\n\n/* Mobile adjustments */\n@media only screen and (max-width: 600px) {\n  .dashboardRoot {\n    padding-top: 95px;\n  }\n\n\n  .logo {\n    font-size: 20px;\n    top: 30px;\n    left: 25px;\n  }\n\n  .navbar {\n    top: 15px;\n    z-index: 999;\n  }\n\n  .navbar ul {\n    gap: 10px;\n  }\n\n  .container {\n    width: 100%;\n    padding: 10px;\n    box-shadow: none;\n  }\n\n  .containerWrapper {\n    flex-direction: column;\n  }\n\n  button {\n    font-size: 14px;\n    padding: 10px;\n  }\n}\n\n@media only screen and (max-width: 400px) {\n  .success, .error {\n    right: 10px;\n    bottom: 10px;\n    padding: 5px;\n    font-size: 12px;\n  }\n\n  .dismiss-button {\n    font-size: 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
